// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portfolio-section {
  text-align: center;
}
  
.portfolio-carousel {
  max-width: 800px;
  margin: 0 auto;
}
  
.portfolio-item img {
  width: 100%;
  height: 400px; /* or auto with aspect-ratio */
  object-fit: cover;
  margin: 0 auto;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

  /* Container for categories */
.portfolio-categories {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

/* Center content inside each category */
.portfolio-category {
  text-align: center;
}

.slick-slider {
  position: relative;
}
  
/* Position arrows on top of the images */
.slick-prev,
.slick-next {
  z-index: 10;
  width: 40px;
  height: 40px;
  top: 50%;
  transform: translateY(-50%);
}
  
/* Left arrow */
.slick-prev {
  left: 30px;  /* inside left edge */
}

/* Right arrow */
.slick-next {
  right: 30px; /* inside right edge */
}
  
/* Make arrow icons visible + styled */
.slick-prev:before,
.slick-next:before {
  color: white;
  opacity: 0.9;
  font-size: 30px;
}`, "",{"version":3,"sources":["webpack://./src/Sections/Portfolio/Portfolio.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa,EAAE,8BAA8B;EAC7C,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;EAEE,6BAA6B;AAC/B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,UAAU,GAAG,qBAAqB;AACpC;;AAEA,gBAAgB;AAChB;EACE,WAAW,EAAE,sBAAsB;AACrC;;AAEA,sCAAsC;AACtC;;EAEE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".portfolio-section {\n  text-align: center;\n}\n  \n.portfolio-carousel {\n  max-width: 800px;\n  margin: 0 auto;\n}\n  \n.portfolio-item img {\n  width: 100%;\n  height: 400px; /* or auto with aspect-ratio */\n  object-fit: cover;\n  margin: 0 auto;\n  border-radius: 10px;\n  overflow: hidden;\n  position: relative;\n}\n\n  /* Container for categories */\n.portfolio-categories {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n/* Center content inside each category */\n.portfolio-category {\n  text-align: center;\n}\n\n.slick-slider {\n  position: relative;\n}\n  \n/* Position arrows on top of the images */\n.slick-prev,\n.slick-next {\n  z-index: 10;\n  width: 40px;\n  height: 40px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n  \n/* Left arrow */\n.slick-prev {\n  left: 30px;  /* inside left edge */\n}\n\n/* Right arrow */\n.slick-next {\n  right: 30px; /* inside right edge */\n}\n  \n/* Make arrow icons visible + styled */\n.slick-prev:before,\n.slick-next:before {\n  color: white;\n  opacity: 0.9;\n  font-size: 30px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
